var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    on: {
      change: _vm.seachFun
    },
    model: {
      value: _vm.form.isOpen,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isOpen", $$v);
      },
      expression: "form.isOpen"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("总系统")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("客户系统")) + " ")])], 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("权限名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("权限名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("权限描述")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("权限描述"),
      allowClear: ""
    },
    model: {
      value: _vm.form.description,
      callback: function ($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("权限类型")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("权限类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("菜单权限")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("数据权限")) + " ")])], 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.seachFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1), _vm.isAuth("home.permissionsStore") ? _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.permissionsFun({
          isOpen: _vm.form.isOpen
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("新增权限")) + " ")])], 1) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (text) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _vm._v(" " + _vm._s(text) + " ")], 2)];
      }
    }, {
      key: "type",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == 1 ? _vm.$t("Menu菜单权限") : _vm.$t("数据权限")) + " ")];
      }
    }, {
      key: "isOpen",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == 1 ? _vm.$t("是") : _vm.$t("否")) + " ")];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: _vm.isChecked(text === 1)
          },
          on: {
            click: checked => _vm.checkedFun(checked, record.id)
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [record.associationId == 0 && record.type == 1 && _vm.isAuth("home.permissionsFieldList") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.configureFun(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("字段配置")) + " ")]) : _vm._e(), _vm.isAuth("home.permissionsEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.permissionsFun(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.permissionsDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.delItem(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.fieldVisible ? _c("field-model", {
    ref: "fieldRef",
    on: {
      cancel: function ($event) {
        _vm.fieldVisible = false;
      }
    }
  }) : _vm._e(), _vm.authorityDialogVisible ? _c("authority-model", {
    ref: "fieldRef",
    attrs: {
      currentRow: _vm.currentRow,
      dialogVisible: _vm.authorityDialogVisible
    },
    on: {
      ok: _vm.handleOk,
      cancel: function ($event) {
        _vm.authorityDialogVisible = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };